module.exports = __webpack_public_path__ + "img/american_express.07bc54fe.png";